if (!window.FlipCard) {
  class FlipCard extends HTMLElement {
    connectedCallback () {
      this.addEventListener('click', this.toggleCard)
      document.addEventListener('click', this.handleClickOutside.bind(this))
    }

    handleClickOutside (event) {
      if (!this.contains(event.target)) {
        this.classList.remove('is-Active')
      }
    }

    toggleCard (event) {
      event.stopPropagation()

      document.querySelectorAll('.sec-Glossary_GridItem').forEach(card => {
        if (card !== this) {
          card.classList.remove('is-Active')
        }
      })

      // Toggle active class on clicked card
      this.classList.toggle('is-Active')
    }
  }

  customElements.define('flip-card', FlipCard)
}

/*
  Custom Select
  - Handles the custom select
*/
if (!window.CustomSelect) {
  class CustomSelect extends HTMLElement {
    constructor () {
      super()
      this.id = this.getAttribute('data-id')
      this.trigger = this.querySelector('[data-select-trigger]')
      this.valueSpan = this.querySelector('[data-select-value]')
      this.options = this.querySelectorAll('[data-select-option]')
      this.customSelect = this.querySelector('.custom-select')
      this.nativeSelect = document.querySelector(`select#${this.id}`)
      this.form = this.closest('form')
      // Close select when clicking outside
      document.addEventListener('click', (e) => {
        if (!this.contains(e.target)) {
          this.customSelect.classList.remove('open')
        }
      })

      this.addEventListener('click', () => {
        this.customSelect.classList.toggle('open')
      })

      this.options?.forEach((option) => {
        option.addEventListener('click', () => {
          const value = option.dataset.value
          this.setValue(value, option.textContent)
          this.nativeSelect.dispatchEvent(new Event('change', { bubbles: true }))
        })
      })

      this.nativeSelect?.addEventListener('change', () => {
        const value = this.nativeSelect.value
        this.setValue(value, this.nativeSelect.options[value].textContent)
      })

      this.form?.addEventListener('reset', () => {
        this.setValue(this.nativeSelect.options[0].value, this.nativeSelect.options[0].textContent)
      })
    }

    setValue (value, text) {
      this.valueSpan.textContent = text
      this.nativeSelect.value = value
    }
  }

  customElements.define('custom-select', CustomSelect)
}
